import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import topGainersLosers from "./topGainersLosers";
import drivingMarketParamsReducer from "../drivingMarketParams";
export default combineReducers({
    reducersData: topGainersLosers,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
